import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { contentLibraryFileShareRequested } from 'features/content-library/actions';

export function* shareContentLibraryFileSaga(
  action: ReturnType<typeof contentLibraryFileShareRequested>
) {
  const { id, personal, targetUsers } = action.payload;

  yield call(SignalingSocket.send, {
    event: 'shareLibraryFile',
    data: {
      id,
      personal,
      targetUsers,
    },
  });
}
